<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    :format="dateFormat"
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select
                    placeholder="Ex: Value's < 50 Million Rupiah"
                    v-model="kategori"
                    class="width-full"
                    initialValue="less"
                    allowClear
                  >
                    <a-select-option value="less"
                      >Value's &#60; 50 Million Rupiah</a-select-option
                    >
                    <a-select-option value="over"
                      >Value's &#62;= 50 Million Rupiah</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="delivered"
                      >Delivered</a-select-option
                    >
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process"
                      >On Process</a-select-option
                    >
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred"
                      >Transferred</a-select-option
                    >
                    <a-select-option value="closed">Closed</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="UM PP List"
        createLink="UmppCreate"
        manifestLink="UmppManifest"
        editLink="UmppEdit"
        :dataList="umppSearch"
        :isTransactional="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListUmPp",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dateFormat: "DD MMM YYYY",
      umList: [],
      search: "",
      tempList: "",
      kategori: undefined,
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    umppSearch: function () {
      var self = this;
      let searchingOutput = this.umList;

      if (this.search) {
        searchingOutput = _.filter(
          searchingOutput,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        searchingOutput = searchingOutput.filter((item) => {
          return this.kategori == "less"
            ? item.realisasirp < 50000000
            : item.realisasirp >= 50000000;
        });
      }

      if (this.status) {
        searchingOutput = _.filter(
          searchingOutput,
          (item) => item.status.toLowerCase() === self.status.toLowerCase()
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        searchingOutput = _.filter(
          searchingOutput,
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      return searchingOutput;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "um_pp",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            const date = data.tgl_buat;
            this.umList.push({
              title: data.no_um,
              subtitle: { deskripsi: data.deskripsi },
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                [
                  {
                    label: date,
                    value: "",
                  },
                ],
                [
                  {
                    label: "Estimated value",
                    value: this.formatCurrency(data.currency, data.value_um),
                  },
                ],
                [
                  {
                    label: "Realization value",
                    value:
                      data.lk_realisasi == "0"
                        ? "There are no reports yet"
                        : this.formatCurrency(data.currency, data.realisasi),
                  },
                ],
              ],
              status: data.status,
              id: data.id_um,
              tgl_buat: data.tgl_buat,
              peruntukan: data.peruntukan,
              canceled_Status: (data.dana_sts == 1 ? "Canceled" : ""),
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : null
                : null,
              searchQ:
                data.no_um +
                " " +
                data.value_um +
                " " +
                data.realisasi +
                " " +
                data.deskripsi,
              realisasirp: data.realisasirp,
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "umpp",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
          //this.fetchData();
          //this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
          return;
        });
    },
  },
};
</script>
